import { render, staticRenderFns } from "./ProjectRessource.vue?vue&type=template&id=03194458"
import script from "./ProjectRessource.vue?vue&type=script&lang=js"
export * from "./ProjectRessource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports